var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 72,
    viewBox: "0 0 159 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.286317 6.66309C0.42111 6.4834 0.67572 6.27376 0.840468 6.18392C1.05015 6.06413 5.19879 6.01921 14.9638 6.00423C26.4063 6.00423 28.8476 6.03418 29.192 6.21387C29.4167 6.31869 29.6863 6.58822 29.7911 6.81283C29.881 7.02246 29.9708 7.33692 29.9708 7.50163C29.9708 7.66635 29.881 7.9808 29.7911 8.19044C29.6863 8.41505 29.4167 8.68458 29.192 8.7894C28.8476 8.96908 26.4063 8.99903 14.9938 8.99903C5.13888 8.99903 1.12503 8.95411 0.885399 8.83432C0.690697 8.74447 0.42111 8.51986 0.286317 8.34017C0.136546 8.17546 0.0167295 7.78614 0.0167295 7.50163C0.0167295 7.21713 0.136546 6.8278 0.286317 6.66309Z",
    fill: "url(#paint0_linear_624_1331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.214 7.48666C44.214 7.02246 44.3338 6.76791 44.6484 6.43848L45.0827 5.98926L59.0263 6.0791L59.4307 6.49837C59.7452 6.81283 59.8501 7.05241 59.8501 7.50163C59.8501 7.95085 59.7452 8.19044 59.0263 8.92416L45.0977 8.99903L44.6484 8.54981C44.2889 8.19044 44.1991 7.9808 44.214 7.48666Z",
    fill: "url(#paint1_linear_624_1331)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.27134 12.3532C0.406133 12.1436 0.660743 11.919 0.825491 11.8441C1.00522 11.7842 7.35549 11.7093 14.9489 11.7093C26.4213 11.7093 28.8326 11.7393 29.1771 11.904C29.4017 12.0238 29.6713 12.2933 29.7761 12.5029C29.881 12.7276 29.9708 13.027 29.9708 13.1917C29.9708 13.3565 29.881 13.6859 29.7612 13.9105C29.6563 14.1351 29.3568 14.4046 29.1321 14.5095C28.7877 14.6592 25.7323 14.6891 0.735628 14.6143L0.376179 14.21C0.136546 13.9404 0.0167295 13.611 0.0167295 13.2666C0.0167295 12.9821 0.121569 12.5778 0.27134 12.3532Z",
    fill: "url(#paint2_linear_624_1331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3454 12.3981C43.4951 12.1735 43.7647 11.919 43.9444 11.8441C44.1242 11.7692 47.5539 11.7243 59.0114 11.7692L59.4307 12.1885C59.7452 12.5029 59.8501 12.7575 59.8501 13.2217C59.8501 13.7158 59.7602 13.8955 58.8766 14.6891H44.0493L43.555 14.2549C43.1956 13.9255 43.0758 13.7009 43.0758 13.3115C43.0758 13.042 43.1956 12.6227 43.3454 12.3981Z",
    fill: "url(#paint3_linear_624_1331)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.1665 18.1332C0.241385 17.9685 0.495995 17.7438 0.720651 17.6241C1.0801 17.4294 3.13196 17.3994 14.9489 17.3994C26.4063 17.3994 28.8326 17.4294 29.1771 17.5941C29.4017 17.7139 29.6713 17.9834 29.7761 18.1931C29.881 18.4177 29.9708 18.7172 29.9708 18.8819C29.9708 19.0466 29.881 19.361 29.7761 19.5856C29.6713 19.7953 29.4017 20.0648 29.1771 20.1846C28.8326 20.3493 26.3764 20.3793 0.915353 20.3793L0.466041 19.93C0.136546 19.6156 0.0167295 19.3461 0.0167295 18.9567C0.0167295 18.6722 0.0766378 18.2979 0.1665 18.1332Z",
    fill: "url(#paint4_linear_624_1331)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1967 18.5075C39.2716 18.2679 39.5711 17.9086 39.8557 17.7289L40.3649 17.3845L59.0114 17.4593L59.4307 17.8786C59.7452 18.1931 59.8501 18.4326 59.8501 18.9118C59.8501 19.406 59.7602 19.5856 58.8766 20.3793H49.5908C42.0424 20.3793 40.2301 20.3493 39.8857 20.1846C39.661 20.0648 39.3764 19.7504 39.2716 19.4659C39.1218 19.1065 39.1069 18.8369 39.1967 18.5075Z",
    fill: "url(#paint5_linear_624_1331)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.286317 23.7484C0.42111 23.5687 0.67572 23.3441 0.840468 23.2543C1.05015 23.1345 3.86583 23.1045 19.9662 23.1644L20.3256 23.5687C20.5653 23.8532 20.6851 24.1677 20.6851 24.542C20.6851 24.8565 20.5952 25.2458 20.4754 25.4105C20.3706 25.5752 20.086 25.7849 19.8464 25.8897C19.5019 26.0394 17.3602 26.0844 0.735628 26.0095L0.376179 25.5902C0.136546 25.3057 0.0167295 25.0062 0.0167295 24.6169C0.0167295 24.3174 0.136546 23.9131 0.286317 23.7484Z",
    fill: "url(#paint6_linear_624_1331)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1206 24.0329C30.2854 23.7334 30.5699 23.389 30.7497 23.2842C31.0342 23.1195 33.76 23.0896 58.9964 23.1644L59.3858 23.5388C59.5955 23.7484 59.8051 24.0778 59.8501 24.2875C59.895 24.4971 59.8651 24.8565 59.7752 25.111C59.7003 25.3506 59.4307 25.6801 59.1761 25.8148C58.7568 26.0694 57.7982 26.0844 44.903 26.0844C34.1944 26.0844 31.0043 26.0394 30.7197 25.8897C30.51 25.7849 30.2255 25.4555 30.0757 25.141C29.8211 24.6019 29.8361 24.557 30.1206 24.0329Z",
    fill: "url(#paint7_linear_624_1331)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.1665 29.5284C0.241385 29.3637 0.495995 29.1241 0.720651 29.0043C1.06512 28.8246 2.3232 28.7947 8.40388 28.7797C15.3982 28.7797 15.6827 28.7947 16.147 29.0792C16.4316 29.2588 16.6712 29.5434 16.7311 29.7829C16.7761 30.0075 16.7761 30.4118 16.7311 30.6814C16.6712 31.0108 16.4915 31.2654 16.147 31.475C15.6827 31.7595 15.3982 31.7745 0.915353 31.7745L0.466041 31.3253C0.136546 30.9958 0.0167295 30.7263 0.0167295 30.3519C0.0167295 30.0674 0.0766378 29.6931 0.1665 29.5284Z",
    fill: "url(#paint8_linear_624_1331)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1206 29.723C30.2854 29.4236 30.5699 29.0792 30.7497 28.9743C31.0192 28.8246 33.8649 28.7797 58.8766 28.7797L59.3259 29.184C59.5955 29.4236 59.8201 29.8279 59.895 30.1423C59.9849 30.6365 59.9399 30.7413 58.9065 31.7745H44.918C31.828 31.7745 30.9144 31.7595 30.5699 31.5049C30.3752 31.3702 30.1206 31.0258 30.0158 30.7562C29.8361 30.337 29.851 30.2172 30.1206 29.723Z",
    fill: "url(#paint9_linear_624_1331)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0.256362 35.0987C0.391156 34.904 0.645766 34.6794 0.810514 34.6195C0.990238 34.5447 4.1504 34.4848 7.83475 34.4698C12.912 34.4698 14.6343 34.5147 14.9339 34.6495C15.1436 34.7543 15.4131 35.0238 15.533 35.2484C15.6528 35.4731 15.7426 35.8025 15.7426 35.9672C15.7426 36.1319 15.6378 36.4613 15.518 36.7159C15.3982 36.9555 15.1585 37.225 14.9938 37.3149C14.7991 37.4047 12.1032 37.4646 0.915353 37.4646L0.466041 37.0154C0.121569 36.671 0.0167295 36.4314 0.0167295 35.9971C0.0167295 35.6977 0.121569 35.2784 0.256362 35.0987Z",
    fill: "url(#paint10_linear_624_1331)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1206 35.2484C30.3003 34.9789 30.5849 34.6944 30.7646 34.6195C30.9593 34.5447 36.9352 34.4997 59.0413 34.5447L59.4906 35.0238C59.7303 35.2934 59.925 35.6827 59.925 35.8923C59.925 36.102 59.8501 36.4164 59.7752 36.5961C59.6853 36.7908 59.4157 37.0603 59.1761 37.1951C58.7568 37.4496 57.7982 37.4646 30.8695 37.4646L30.4202 37.0453C30.1655 36.8207 29.9259 36.4314 29.881 36.1918C29.8361 35.8774 29.9109 35.5928 30.1206 35.2484Z",
    fill: "url(#paint11_linear_624_1331)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.1665 40.9086C0.241385 40.7439 0.495995 40.5043 0.720651 40.3845C1.06512 40.2048 2.3232 40.1599 8.35895 40.1599C14.4995 40.1599 15.6528 40.1899 16.0422 40.3845C16.2818 40.5043 16.5514 40.7738 16.6413 40.9835C16.7162 41.1931 16.791 41.5525 16.791 41.8071C16.791 42.0916 16.6413 42.406 15.9074 43.1547H0.915353L0.466041 42.7055C0.136546 42.3761 0.0167295 42.1065 0.0167295 41.7322C0.0167295 41.4477 0.0766378 41.0733 0.1665 40.9086Z",
    fill: "url(#paint12_linear_624_1331)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0457 41.0584C30.1655 40.8038 30.4202 40.5043 30.5999 40.3845C30.8994 40.1899 32.7116 40.1599 58.8766 40.1599L59.4008 40.684C59.7602 41.0434 59.925 41.3429 59.925 41.6573C59.925 41.9568 59.7602 42.2712 58.9065 43.1547H30.8695L30.4202 42.7804C30.1655 42.5707 29.9409 42.2114 29.896 41.9568C29.851 41.7022 29.9259 41.2979 30.0457 41.0584Z",
    fill: "url(#paint13_linear_624_1331)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.1665 46.5987C0.241385 46.434 0.495995 46.1944 0.720651 46.0746C1.0801 45.895 2.56283 45.865 10.306 45.85C18.1689 45.85 19.5468 45.88 19.9362 46.0746C20.1908 46.1944 20.4754 46.5239 20.6102 46.8233C20.8049 47.2576 20.8049 47.4223 20.6401 47.8266C20.5353 48.0961 20.2807 48.4405 20.071 48.5753C19.7415 48.8299 19.0376 48.8448 0.915353 48.8448L0.466041 48.3956C0.136546 48.0662 0.0167295 47.7967 0.0167295 47.4223C0.0167295 47.1378 0.0766378 46.7634 0.1665 46.5987Z",
    fill: "url(#paint14_linear_624_1331)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1206 46.6287C30.3003 46.3591 30.5849 46.0746 30.7646 45.9998C30.9593 45.9249 36.9352 45.88 59.0413 45.9249L59.4906 46.4041C59.7303 46.6736 59.925 47.0629 59.925 47.2726C59.925 47.4822 59.8501 47.7966 59.7752 47.9763C59.6853 48.171 59.4157 48.4405 59.1761 48.5753C58.7568 48.8299 57.7982 48.8448 30.8695 48.8448L30.4202 48.4256C30.1655 48.201 29.9259 47.8116 29.881 47.572C29.8361 47.2576 29.9109 46.9731 30.1206 46.6287Z",
    fill: "url(#paint15_linear_624_1331)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00175247 53.0226C-0.0132246 52.5135 0.0616607 52.3338 0.466041 51.9744L0.945307 51.5402H14.859C26.9305 51.5402 28.8326 51.5701 29.222 51.7648C29.4616 51.8846 29.7312 52.1541 29.8211 52.3637C29.896 52.5734 29.9708 52.9327 29.9708 53.1873C29.9708 53.4718 29.8211 53.7863 29.0872 54.535H0.915353L0.466041 54.0857C0.121569 53.7413 0.0167295 53.4868 0.00175247 53.0226Z",
    fill: "url(#paint16_linear_624_1331)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3465 52.3038C39.4813 52.1092 39.7209 51.8546 39.9006 51.7498C40.1702 51.5851 42.0873 51.5402 58.8766 51.5402L59.4008 52.0642C59.7153 52.3787 59.925 52.7381 59.925 52.9627C59.925 53.1573 59.8501 53.4868 59.7602 53.6665C59.6704 53.8611 59.4457 54.1306 59.266 54.2654C58.9814 54.505 58.2326 54.52 40.1552 54.535L39.6311 54.0109C39.2816 53.6615 39.1069 53.347 39.1069 53.0675C39.1069 52.8429 39.2267 52.4985 39.3465 52.3038Z",
    fill: "url(#paint17_linear_624_1331)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0.256362 57.8592C0.391156 57.6645 0.645766 57.4399 0.810514 57.38C0.990238 57.3051 7.35549 57.2452 14.9489 57.2303C26.9455 57.2303 28.8326 57.2602 29.222 57.4549C29.4616 57.5747 29.7312 57.8442 29.8211 58.0538C29.896 58.2485 29.9708 58.6229 29.9708 58.8774C29.9708 59.132 29.8211 59.4913 29.2519 60.1502L0.915353 60.2251L0.466041 59.7758C0.121569 59.4314 0.0167295 59.1919 0.0167295 58.7576C0.0167295 58.4581 0.121569 58.0389 0.256362 57.8592Z",
    fill: "url(#paint18_linear_624_1331)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1507 58.0838C43.2405 57.9041 43.4951 57.6346 43.7198 57.4998C44.0792 57.2602 44.7682 57.2303 51.3431 57.2303C57.3789 57.2303 58.6519 57.2602 59.0563 57.4399C59.3259 57.5597 59.6404 57.8292 59.7303 58.0389C59.8351 58.2485 59.925 58.563 59.925 58.7277C59.925 58.8924 59.8351 59.2068 59.7153 59.4314C59.6104 59.6561 59.3409 59.9256 59.1162 60.0304C58.8167 60.1801 56.9595 60.2251 51.4629 60.2251C44.8131 60.2251 44.1541 60.1951 43.7497 59.9555C43.5101 59.8208 43.2405 59.5512 43.1507 59.3566C43.0608 59.1769 43.0009 58.8924 43.0009 58.7277C43.0009 58.563 43.0758 58.2784 43.1507 58.0838Z",
    fill: "url(#paint19_linear_624_1331)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00175247 64.4028C-0.0132246 63.8937 0.0616607 63.714 0.466041 63.3546L0.945307 62.9204H14.859C26.9305 62.9204 28.8326 62.9503 29.222 63.145C29.4616 63.2648 29.7312 63.5044 29.8211 63.6691C29.896 63.8338 29.9708 64.1932 29.9708 64.4927C29.9708 64.867 29.851 65.1365 29.0872 65.9152H0.915353L0.466041 65.466C0.121569 65.1216 0.0167295 64.867 0.00175247 64.4028Z",
    fill: "url(#paint20_linear_624_1331)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1691 64.4178C44.1541 63.8638 44.229 63.699 44.6334 63.3397L45.0977 62.9204H51.9122C57.0494 62.9204 58.8167 62.9653 59.1162 63.1001C59.3409 63.2049 59.6104 63.4744 59.7153 63.699C59.8351 63.9236 59.925 64.313 59.925 64.5675C59.925 64.867 59.7752 65.1515 58.9964 65.9152H45.0228L44.6034 65.4959C44.2739 65.1815 44.1691 64.9419 44.1691 64.4178Z",
    fill: "url(#paint21_linear_624_1331)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M154.387 11.9287C155.387 11.9287 156.387 11.9287 157.418 11.9287C157.484 14.6595 157.524 17.3901 157.56 20.1214C157.579 20.8974 157.598 21.6734 157.617 22.473C157.625 23.2177 157.632 23.9625 157.64 24.7298C157.652 25.4163 157.663 26.1027 157.676 26.81C157.418 28.5982 157.418 28.5982 156.509 29.9627C154.677 31.1826 153.467 31.1313 151.276 31.0933C150.531 31.086 149.787 31.0787 149.019 31.0712C148.243 31.0521 147.467 31.0331 146.668 31.0134C145.883 31.0032 145.098 30.9929 144.29 30.9824C142.351 30.9556 140.413 30.9182 138.475 30.8714C138.1 30.1212 138.1 30.1212 137.718 29.356C137.218 29.856 136.717 30.3561 136.202 30.8714C134.38 31.0536 134.38 31.0536 132.066 31.0434C131.201 31.0433 130.336 31.0432 129.446 31.0431C128.04 31.0313 128.04 31.0313 126.607 31.0194C125.65 31.0172 124.694 31.0151 123.708 31.0129C121.165 31.0058 118.621 30.9922 116.077 30.9754C113.482 30.9599 110.887 30.953 108.292 30.9454C103.199 30.9286 98.1062 30.9032 93.0135 30.8714C92.7791 31.3558 92.5447 31.8403 92.3031 32.3394C91.4981 33.9022 91.4981 33.9022 90.7404 34.6599C89.0067 34.7752 87.2686 34.828 85.5312 34.8493C84.1042 34.8786 84.1042 34.8786 82.6484 34.9085C80.1326 34.6599 80.1326 34.6599 78.8527 33.7496C77.5209 31.922 77.5986 30.7651 77.6376 28.5183C77.6449 27.7736 77.6522 27.0288 77.6598 26.2615C77.6788 25.4855 77.6979 24.7095 77.7175 23.9099C77.7277 23.1251 77.738 22.3403 77.7486 21.5317C77.7754 19.5932 77.8128 17.6554 77.8596 15.7172C79.1098 15.7172 80.36 15.7172 81.648 15.7172C81.648 20.7181 81.648 25.719 81.648 30.8714C84.1484 30.8714 86.6488 30.8714 89.225 30.8714C89.225 25.8705 89.225 20.8696 89.225 15.7172C90.4752 15.7172 91.7254 15.7172 93.0135 15.7172C93.0135 19.4679 93.0135 23.2185 93.0135 27.0828C107.016 27.0828 121.018 27.0828 135.444 27.0828C135.444 23.3322 135.444 19.5815 135.444 15.7172C136.445 15.7172 137.445 15.7172 138.475 15.7172C138.475 19.4679 138.475 23.2185 138.475 27.0828C143.726 27.0828 148.977 27.0828 154.387 27.0828C154.387 22.082 154.387 17.0811 154.387 11.9287Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.394 41.9366C145.992 41.9337 146.589 41.9308 147.205 41.9277C147.827 41.9365 148.448 41.9453 149.088 41.9544C150.02 41.9412 150.02 41.9412 150.97 41.9277C151.867 41.9321 151.867 41.9321 152.781 41.9366C153.326 41.9392 153.872 41.9417 154.433 41.9444C156.386 42.3341 157.038 42.8859 158.18 44.5116C158.438 46.2999 158.438 46.2999 158.402 48.3801C158.395 49.1248 158.387 49.8696 158.38 50.6369C158.361 51.4129 158.342 52.1889 158.322 52.9885C158.307 54.1657 158.307 54.1657 158.291 55.3667C158.264 57.3052 158.227 59.243 158.18 61.1812C156.93 61.1812 155.68 61.1812 154.392 61.1812C154.392 56.1803 154.392 51.1794 154.392 46.027C150.891 46.027 147.39 46.027 143.784 46.027C143.784 51.0279 143.784 56.0288 143.784 61.1812C142.534 61.1812 141.283 61.1812 139.995 61.1812C139.929 58.4504 139.889 55.7198 139.853 52.9885C139.834 52.2125 139.815 51.4364 139.796 50.6369C139.788 49.8922 139.781 49.1474 139.773 48.3801C139.761 47.6936 139.75 47.0072 139.737 46.2999C139.995 44.5116 139.995 44.5116 140.95 43.1522C142.556 42.0395 143.452 41.9457 145.394 41.9366Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8638 42.2393C79.114 42.2393 80.3642 42.2393 81.6523 42.2393C81.6523 47.2401 81.6523 52.241 81.6523 57.3934C85.1529 57.3934 88.6534 57.3934 92.2601 57.3934C92.2601 58.6436 92.2601 59.8938 92.2601 61.1819C90.2864 61.2432 88.3147 61.2883 86.3405 61.324C85.5018 61.3526 85.5018 61.3526 84.6461 61.3817C80.5038 61.4379 80.5038 61.4379 78.8346 60.2733C77.5328 58.4436 77.6031 57.2725 77.6418 55.0403C77.6492 54.2956 77.6565 53.5508 77.664 52.7835C77.6831 52.0075 77.7021 51.2315 77.7217 50.432C77.732 49.6472 77.7423 48.8623 77.7528 48.0538C77.7796 46.1152 77.817 44.1774 77.8638 42.2393Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M154.389 11.9287C155.389 11.9287 156.389 11.9287 157.42 11.9287C157.464 14.6753 157.491 17.4219 157.515 20.1688C157.527 20.9511 157.54 21.7335 157.553 22.5396C157.558 23.2868 157.563 24.034 157.568 24.8038C157.576 25.4942 157.584 26.1847 157.592 26.896C157.42 28.5982 157.42 28.5982 155.905 30.1137C154.202 30.2857 154.202 30.2857 152.11 30.2617C151.363 30.2568 150.616 30.2519 149.846 30.2469C148.672 30.2278 148.672 30.2278 147.475 30.2084C146.687 30.2015 145.899 30.1947 145.087 30.1877C143.136 30.1698 141.186 30.1448 139.235 30.1137C138.985 29.1135 138.735 28.1133 138.478 27.0828C143.728 27.0828 148.979 27.0828 154.389 27.0828C154.389 22.082 154.389 17.0811 154.389 11.9287Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M110.469 41.9541C112.374 42.3158 113.044 43.002 114.228 44.5098C114.529 46.1434 114.529 46.1435 114.512 47.9189C114.518 48.505 114.523 49.0915 114.529 49.6953C114.227 51.3289 114.227 51.3292 113.461 52.6699C111.048 54.163 108.494 53.8376 105.751 53.7441C104.899 53.7288 104.899 53.7286 104.03 53.7129C102.631 53.6861 101.231 53.646 99.832 53.6025V57.3906H113.47V61.1787C111.118 61.2227 108.766 61.2497 106.414 61.2734C105.413 61.2925 105.412 61.2931 104.391 61.3125C103.749 61.3174 103.107 61.3221 102.445 61.3271C101.854 61.3351 101.262 61.3434 100.653 61.3516C99.0739 61.1795 99.0737 61.1794 96.8008 59.6641C96.5187 58.0554 96.5185 58.0547 96.5254 56.0879C96.5259 55.3819 96.5268 54.6757 96.5273 53.9482C96.5396 53.209 96.5519 52.4697 96.5645 51.708C96.5608 50.5989 96.5604 50.5983 96.5566 49.4668C96.6014 43.5846 97.1387 42.0463 103.187 41.9922C104.128 41.9958 104.128 41.9963 105.088 42C105.712 41.9878 106.337 41.9755 106.98 41.9629C107.582 41.9624 108.183 41.9614 108.803 41.9609C109.353 41.9587 109.902 41.9564 110.469 41.9541ZM99.833 46.0254V52.0869C101.942 50.4496 101.943 50.4493 104.15 50.2578C105.294 50.1771 105.294 50.1768 106.415 50.0977C107.567 50.011 107.568 50.0117 108.697 49.9268C109.29 49.8885 109.865 49.8516 110.44 49.8145V46.0254H99.833Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M132.354 41.9795C133.934 42.2375 133.934 42.2379 135.263 43.1826C136.439 44.8371 136.5 45.7832 136.509 47.8018C136.513 48.7496 136.513 48.75 136.518 49.7168C136.509 50.3741 136.5 51.0317 136.491 51.709C136.5 52.3663 136.509 53.0239 136.518 53.7012C136.515 54.3331 136.512 54.9652 136.509 55.6162C136.506 56.1927 136.504 56.7693 136.501 57.3633C136.124 59.3421 135.557 60.0065 133.934 61.1807C132.46 61.4747 132.46 61.4747 130.809 61.4824C130.211 61.4854 129.613 61.4882 128.997 61.4912C128.376 61.4824 127.754 61.4739 127.114 61.4648C126.183 61.478 126.183 61.4778 125.232 61.4912C124.336 61.4868 124.336 61.4869 123.421 61.4824C122.876 61.4799 122.331 61.4773 121.77 61.4746C119.88 61.0975 119.201 60.4043 118.022 58.9072C117.721 57.2736 117.721 57.2735 117.738 55.498C117.732 54.912 117.727 54.3255 117.721 53.7217C118.023 52.0879 118.022 52.0878 118.789 50.7471C121.202 49.2539 123.756 49.5794 126.499 49.6729C127.067 49.6831 127.635 49.6935 128.22 49.7041C129.619 49.7308 131.02 49.771 132.419 49.8145V46.0264H119.538V42.2373C121.89 42.1713 124.241 42.1314 126.594 42.0957C127.261 42.0767 127.929 42.0577 128.617 42.0381C129.58 42.0271 129.58 42.0268 130.562 42.0156C131.449 41.9978 131.45 41.9977 132.354 41.9795ZM121.811 53.6016V57.3906H132.418V53.6016H121.811Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.387 33.1465C130.637 33.1465 131.887 33.1465 133.175 33.1465C133.175 34.3967 133.175 35.6469 133.175 36.935C131.925 36.935 130.675 36.935 129.387 36.935C129.387 35.6848 129.387 34.4346 129.387 33.1465Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M135.448 33.1465C136.448 33.1465 137.449 33.1465 138.479 33.1465C138.479 34.3967 138.479 35.6469 138.479 36.935C137.479 36.935 136.479 36.935 135.448 36.935C135.448 35.6848 135.448 34.4346 135.448 33.1465Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9219 10.4141C84.922 10.4141 85.9222 10.4141 86.9527 10.4141C86.9527 11.6643 86.9527 12.9145 86.9527 14.2026C85.9525 14.2026 84.9523 14.2026 83.9219 14.2026C83.9219 12.9524 83.9219 11.7022 83.9219 10.4141Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_624_1331",
    x1: 29.963,
    y1: 5.98926,
    x2: 29.963,
    y2: 65.9152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#244392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE2B87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeen);
export default __webpack_public_path__ + "static/media/leen.c79f60919de957dd811d3532f0557e4d.svg";
export { ForwardRef as ReactComponent };